module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tocchaptitle"
  }, [_c('a', {
    attrs: {
      "id": "contents"
    }
  }), _vm._v("The Web of Life")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/07_weaving#weaving"
    }
  }, [_vm._v("Weaving")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/08_part01#p1"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRAND OF")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMILY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/09_chapter01#c1"
    }
  }, [_vm._v("The Little Things")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/10_chapter02#c2"
    }
  }, [_vm._v("The Essence of Family")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/11_chapter03#c3"
    }
  }, [_vm._v("Preserving Our Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/12_chapter04#c4"
    }
  }, [_vm._v("Christmas Love Letters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter05#c5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Man Who Reappeared")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter06#c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Garden")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter07#c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Pond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter08#c8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Treasure Chest")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/17_part02#p2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRAND OF")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIENDSHIP")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter09#c9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The SLOP House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter10#c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Greatest Gift Is Your Honest Self")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter11#c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Our Pets Teach Us")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter12#c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Rivers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/22_chapter13#c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unfolding Friendship")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/23_chapter14#c14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Old Woman of the Prairie")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/24_part03#p3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRAND OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMUNITY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/25_chapter15#c15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Woman Across the Cul-de-Sac")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/26_chapter16#c16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tara's Neighborhood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/27_chapter17#c17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Being a Good Parent—Neighbor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/28_chapter18#c18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Virtual Reality vs. Real Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/29_chapter19#c19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Great Good Place")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/30_chapter20#c20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bench")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/31_chapter21#c21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Survival Primer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/32_chapter22#c22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Woman of Substance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/33_chapter23#c23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Skinwalkers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/34_chapter24#c24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Protecting the Children of Others")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/35_chapter25#c25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No Fear")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/36_chapter26#c26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Culture of Renewal")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/37_part04#p4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRAND OF")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATURE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/38_chapter27#c27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lion Hound")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/39_chapter28#c28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old-fashioned Reality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/40_chapter29#c29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All Our Relatives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/41_chapter30#c30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The $70 Lizard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/42_chapter31#c31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Connecting Children to Nature")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/43_chapter32#c32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flyover Land")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/44_chapter33#c33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Everyone Has One True Place")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/45_chapter34#c34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wyoming Wind")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/46_chapter35#c35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eating Trout")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/47_part05#p5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRAND OF")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IME")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/48_chapter36#c36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Door of the Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/49_chapter37#c37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haunted Houses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/50_chapter38#c182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moving Our Memories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/51_chapter39#c39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ultimate Go-Cart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/52_chapter40#c40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Love")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/53_chapter41#c41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Virtual Ghost")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/54_chapter42#c43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Found Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/55_chapter43#c43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Virtual Blacksmith Shop")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/56_chapter44#c44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sacred Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/57_chapter45#c45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Closing Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/58_chapter46#c46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seeing Time")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/59_part06#p6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRAND OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/60_chapter47#c47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Angel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/61_chapter48#c48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Music of Inner Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/62_chapter49#c49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Place Afire")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/63_chapter50#c50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Belt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/64_chapter51#c51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Process of Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/65_chapter52#c52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bless This House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/66_chapter53#c53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May the Spirit Move You, One Way or Another")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-350067dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_contents.vue
// module id = 72
// module chunks = 0